var map = {
	"./10.png": "c528",
	"./check.png": "76c8",
	"./computer.png": "d8a7",
	"./cpt.png": "9b8d",
	"./cpt1.png": "0a46",
	"./left-arrow.png": "8512",
	"./none.png": "188e",
	"./pitch1.png": "cf8e",
	"./right-arrow.png": "18b4",
	"./sad-face.png": "25d3",
	"./swords.png": "3958",
	"./uncheck.png": "89d0",
	"./user-head.png": "4d5b",
	"./wreath.png": "ff96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5559";